var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgGlobalEmojiHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED13EF8A-F512-4621-B0E9-980AD400FD0C@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yamu.rocks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About",
    transform: "translate(-1040.000000, -416.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happy",
    transform: "translate(1040.000000, 416.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4D44E",
    cx: 25.5,
    cy: 25.5,
    r: 25.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0199353,45.101223 C1.11030344,35.9578418 0.144178146,13.5675835 14.858767,3 C10.2002969,5.08642361 6.13259798,8.59508774 3.3834177,13.3348105 C-3.58167164,25.3435664 0.551756096,40.699036 12.6157087,47.6322991 C21.4938325,52.734571 32.1923595,51.8531135 40,46.2459604 C32.8560533,49.4454375 24.3223407,49.2978086 17.0199353,45.101223 Z",
    id: "Path",
    fill: "#E8C842"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#ED694A",
    cx: 40,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1464342,24 C38.5128543,23.9978319 37.4605943,25.6587649 38.2899928,27.0012973 C39.1197231,28.3440364 41.1855326,28.322231 42,26.9997472 C40.3520419,26.9974736 39.3228976,25.3371607 40.1464342,24 Z",
    id: "Path",
    fill: "#D8553A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#ED694A",
    cx: 11,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1464936,24 C9.51286844,23.9978319 8.46057937,25.6587489 9.29000083,27.0012684 C10.1197541,28.3439945 12.1856207,28.3222926 13,26.9997182 C11.3521069,26.9973414 10.3231554,25.3369411 11.1464936,24 Z",
    id: "Path",
    fill: "#D8553A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.000000, 15.000000)",
    fill: "#656566"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7564219,7.67268834 C18.1249824,7.90810971 18.6238671,7.81405971 18.8708192,7.46334807 C19.6884589,6.30214675 20.8579535,6.28960016 21.6845167,7.46334807 C21.9329215,7.81603555 22.4325326,7.90682541 22.798914,7.67268834 C23.1674744,7.43746456 23.265944,6.96247256 23.0188881,6.61166212 C21.5656062,4.54740302 18.9993796,4.53386851 17.5366553,6.61166212 C17.2893919,6.96237377 17.3878615,7.43746456 17.7564219,7.67268834 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75148791,6.59634936 C2.50443205,6.9471598 2.60279784,7.42225059 2.97146205,7.65737558 C3.34002249,7.89269815 3.839011,7.79884574 4.08585933,7.44803531 C4.9025652,6.28811828 6.07185226,6.27280552 6.89955684,7.44793651 C7.05447258,7.66804512 7.30858422,7.7869907 7.56746888,7.7869907 C8.20010205,7.7869907 8.59460284,7.10868474 8.23392826,6.59634936 C7.53862321,5.60872561 6.53960859,5.04225221 5.49275996,5.04225221 C4.4460151,5.04244979 3.44679296,5.60892319 2.75148791,6.59634936 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5988091,1.72738501 C21.3100419,1.30218419 23.1542968,1.56902141 24.7917552,2.47879706 C24.9190704,2.54943335 25.0583182,2.58312143 25.1959058,2.58312143 C25.4721186,2.58312143 25.7410681,2.44728241 25.8903807,2.2037601 C26.1139865,1.83901999 25.9845961,1.37074585 25.601509,1.15775027 C23.5944526,0.042783609 21.3186541,-0.280661441 19.1933096,0.24748066 C18.7640488,0.354077241 18.506928,0.771769872 18.6188866,1.18047243 C18.7309489,1.58927378 19.1700671,1.83417918 19.5988091,1.72738501 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20824482,2.47879706 C2.84570325,1.56902141 4.68995812,1.30238177 6.4011909,1.72738501 C6.83014047,1.83408039 7.26915489,1.58917499 7.38111343,1.18047243 C7.49307196,0.771769872 7.23595125,0.354077241 6.8066904,0.24748066 C4.68124217,-0.280463857 2.40554745,0.042684817 0.39849096,1.15775027 C0.015403923,1.37064705 -0.113986525,1.8388224 0.109619261,2.2037601 C0.334366423,2.57037726 0.826921723,2.69060714 1.20824482,2.47879706 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22702777,17.2018695 C6.82318846,17.3767314 6.64482263,17.8300879 6.82848029,18.2145864 C6.92020535,18.4064405 7.02199527,18.5949357 7.13115225,18.7751323 C8.3851086,20.8428492 10.6675478,22 13.0115175,22 C14.1604673,22 15.3241513,21.7219993 16.3885356,21.1368542 C17.6232961,20.4581531 18.5857867,19.4472144 19.1721423,18.2132034 C19.3549698,17.8283097 19.1755664,17.3752495 18.7714158,17.201178 C18.3671614,17.0270077 17.8914155,17.1979178 17.7084842,17.5827127 C17.2613764,18.5235091 16.5271608,19.2944819 15.5852149,19.8122509 C13.116109,21.1693568 9.94785883,20.3610405 8.52238491,18.0105809 C8.43896076,17.8729637 8.36103596,17.728431 8.2907895,17.5813296 C8.10692432,17.1969299 7.63086708,17.0267113 7.22702777,17.2018695 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGlobalEmojiHappy);
export default __webpack_public_path__ + "static/media/img-global-emoji-happy.6a6e1f6ebad2f5f7981ea8bd6620d910.svg";
export { ForwardRef as ReactComponent };